import { gql } from "@apollo/client";

// Liefert alle Service-Jobs (optional gefiltert nach Typ und Status).
// Diese Query orientiert sich an der Backend-Schema-Definition in schema.graphql.
export const FETCH_SERVICE_JOBS = gql`
    query FetchServiceJobs($type: ServiceCreditType, $status: ServiceJobStatus) {
        serviceJobs(type: $type, status: $status) {
            id
            type
            status
            submittedAt
            startedAt
            completedAt
            estimatedCompletion
            inputData
            resultFiles
        }
    }
`; 